import { useState } from "react";

import type { TimelineMode } from "@/components/TimelineModePicker";
import { ToggleSpeakers } from "@/components/ToggleSpeakers/ToggleSpeakers";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

/**
 * `ToggleSpeakers` is an icon-only, tooltip-wrapped button that toggles the
 * timeline between the collapsed "simple" view and the expanded "karaoke" view.
 * It shows the expand (Maximize2) icon while collapsed and the collapse
 * (Minimize2) icon while expanded.
 */
const noop = () => undefined;

function InteractiveState() {
  const [mode, setMode] = useState<TimelineMode>("simple");

  return (
    <div className="flex items-center gap-3">
      <ToggleSpeakers mode={mode} setMode={setMode} />
      <span className="text-sm text-muted-foreground">
        current mode: {mode}
      </span>
    </div>
  );
}

export function PlaygroundToggleSpeakers() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Interactive (click to toggle)
        </PlaygroundSubSectionTitle>
        <InteractiveState />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Collapsed state (shows expand icon)
        </PlaygroundSubSectionTitle>
        <ToggleSpeakers mode="simple" setMode={noop} />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Expanded state (shows collapse icon)
        </PlaygroundSubSectionTitle>
        <ToggleSpeakers mode="karaoke" setMode={noop} />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
